import * as Sentry from '@sentry/react';

import { SENTRY_DSN, ENVIRONMENT, RELEASE } from '@/config';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  release: RELEASE,
  integrations: [Sentry.browserTracingIntegration()],
  normalizeDepth: 10,
  tracesSampleRate: 1.0
});
